export default __webpack_public_path__ + "static/media/JSS.1b412fc7.png";